import { Factory } from 'miragejs';

export default Factory.extend({
  current_installment_number: 1,
  total_installments_number: 3,
});
